import { DayOfWeek } from '../../generated/graphql'

enum FacilityIcon {
  YES = 'YES',
  NO = 'NO',
}
export const MOCK_DATA = {
  stores: [
    {
      id: '101150',
      displayName: 'Homebase Leighton Buzzard',
      urlTag: 'South-East-England-Homebase-Leighton-Buzzard',
      phoneNumber: '03456 407649',
      openingTimes: [
        {
          day: DayOfWeek.Friday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Monday,
          openingTime: '08:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Saturday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Sunday,
          openingTime: '10:00:00',
          closingTime: '16:00:00',
        },
        {
          day: DayOfWeek.Thursday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Tuesday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Wednesday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
      ],
      address: {
        country: 'GB',
        addresseeName: 'Homebase Felixstowe',
        addressLine4: 'Leighton Buzzard',
        addressLine5: 'South East England',
      },
      storeFacility: [
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
      ],
    },
    {
      id: '101159',
      displayName: 'Homebase Leighton Buzzard',
      urlTag: 'South-East-England-Homebase-Leighton-Buzzard',
      phoneNumber: '03456 407649',
      openingTimes: [
        {
          day: DayOfWeek.Friday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Monday,
          openingTime: '08:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Saturday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Sunday,
          openingTime: '10:00:00',
          closingTime: '16:00:00',
        },
        {
          day: DayOfWeek.Thursday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Tuesday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Wednesday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
      ],
      address: {
        country: 'GB',
        addresseeName: 'Homebase Felixstowe',
        addressLine4: 'Leighton Buzzard',
        addressLine5: 'South East England',
      },
      storeFacility: [
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
      ],
    },
    {
      id: '101151',
      displayName: 'Homebase Felixstowe',
      urlTag: 'South-East-England-Homebase-Felixstowe',
      phoneNumber: '03456 407650',
      openingTimes: [
        {
          day: DayOfWeek.Friday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Monday,
          openingTime: '08:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Saturday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Sunday,
          openingTime: '10:00:00',
          closingTime: '16:00:00',
        },
        {
          day: DayOfWeek.Thursday,
          openingTime: '08:30:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Tuesday,
          openingTime: '08:30:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Wednesday,
          openingTime: '08:30:00',
          closingTime: '19:00:00',
        },
      ],
      address: {
        country: 'GB',
        addresseeName: 'Homebase Felixstowe',
        addressLine4: 'Felixstowe',
        addressLine5: 'South East England',
      },
      storeFacility: [
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
      ],
    },
    {
      id: '101152',
      displayName: 'Homebase Dartford',
      urlTag: 'South-East-England-Homebase-Dartford',
      phoneNumber: '03456 407666',
      openingTimes: [
        {
          day: DayOfWeek.Friday,
          openingTime: '09:00:00',
          closingTime: '18:00:00',
        },
        {
          day: DayOfWeek.Monday,
          openingTime: '09:00:00',
          closingTime: '18:00:00',
        },
        {
          day: DayOfWeek.Saturday,
          openingTime: '09:00:00',
          closingTime: '18:00:00',
        },
        {
          day: DayOfWeek.Sunday,
          openingTime: '10:00:00',
          closingTime: '16:00:00',
        },
        {
          day: DayOfWeek.Thursday,
          openingTime: '09:00:00',
          closingTime: '18:00:00',
        },
        {
          day: DayOfWeek.Tuesday,
          openingTime: '09:00:00',
          closingTime: '18:00:00',
        },
        {
          day: DayOfWeek.Wednesday,
          openingTime: '09:00:00',
          closingTime: '18:00:00',
        },
      ],
      address: {
        country: 'GB',
        addresseeName: 'Homebase Felixstowe',
        addressLine4: 'Dartford',
        addressLine5: 'South East England',
      },
      storeFacility: [
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
      ],
    },
    {
      id: '101153',
      displayName: 'Homebase Belfast Galwally',
      urlTag: 'Northern-Ireland-Homebase-Galwally',
      phoneNumber: '03456 407674',
      openingTimes: [
        {
          day: DayOfWeek.Friday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Monday,
          openingTime: '08:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Saturday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Sunday,
          openingTime: '13:00:00',
          closingTime: '18:00:00',
        },
        {
          day: DayOfWeek.Thursday,
          openingTime: '09:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Tuesday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Wednesday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
      ],
      address: {
        country: 'GB',
        addresseeName: 'Homebase Felixstowe',
        addressLine4: 'Galwally',
        addressLine5: 'Northern Ireland',
      },
      storeFacility: [
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
      ],
    },
    {
      id: '101154',
      displayName: 'Homebase Craigavon',
      urlTag: 'Northern-Ireland-Homebase-Craigavon',
      phoneNumber: '03456 407675',
      openingTimes: [
        {
          day: DayOfWeek.Friday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Monday,
          openingTime: '08:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Saturday,
          openingTime: '08:00:00',
          closingTime: '20:00:00',
        },
        {
          day: DayOfWeek.Sunday,
          openingTime: '13:00:00',
          closingTime: '18:00:00',
        },
        {
          day: DayOfWeek.Thursday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Tuesday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
        {
          day: DayOfWeek.Wednesday,
          openingTime: '09:00:00',
          closingTime: '19:00:00',
        },
      ],
      address: {
        country: 'GB',
        addresseeName: 'Homebase Felixstowe',
        addressLine4: 'Craigavon',
        addressLine5: 'Northern Ireland',
      },
      storeFacility: [
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.YES,
          title: 'Facility name',
        },
        {
          icon: FacilityIcon.NO,
          title: 'Facility name',
        },
      ],
    },
  ],
}
